import { readonly } from 'vue';
import { useSafeLocalStorage } from '../../lib/safeLocalStorage';

const wordWrap = useSafeLocalStorage('wordWrap', true);

const toggleWordWrap = () => {
  wordWrap.value = !wordWrap.value;
};

export default function useEditorOptions() {
  return {
    wordWrap: readonly(wordWrap),
    toggleWordWrap
  };
}
